import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FilledButton } from '../filled-button/filled-button';
import { Confirm } from './confirm';
import { Content } from './reload.styled';

export const Reload = ({ id, sendControlMsg }) => {
  const { t } = useTranslation();
  const [confirm, setConfirm] = useState(false);
  const mainRelay = window.config.nodes[id] && window.config.nodes[id].main_relay === true;
  const rightReload = window.haveRight('mnemo.reboot');

  const showConfirm = () => {
    setConfirm(true);
  };

  const closeConfirm = () => {
    setConfirm(false);
  };

  const reload = () => {
    sendControlMsg('racks.reset_main_relay');
    // socket.call('racks.reset_main_relay');
    closeConfirm();
  };

  if (!mainRelay || !rightReload) {
    return null;
  }

  return (
    <Content>
      <FilledButton onClick={showConfirm} color="danger">
        {t('dock.Перезагрузить')}
      </FilledButton>
      {confirm && <Confirm action={reload} close={closeConfirm} period={5} top={0} />}
    </Content>
  );
};
